<template>
  <div class="footer-wtxh-m">
    <p class="footer-text">
      技术支持：中工科创&nbsp;&nbsp;
      京ICP备<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">16012224号</a><br />
      Copyright © 2017-2026 kjcxchina.com All Rights Reserved
      <!-- 版权所有：全国总工会劳动和经济工作部&nbsp;&nbsp;&nbsp;&nbsp;技术支持：中工科创<br /> -->
    </p>
  </div>
</template>

<script>
export default {
  name: "BottomWtxhM",
};
</script>

<style scoped lang="scss">
.footer-wtxh-m {
  background: linear-gradient(180deg, #1d1d1d 0%, #141414 100%);
  padding: 48px 32px;
  // margin-top: 20px;
}
.footer-text {
  font-size: 20px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.8;
  text-align: center;
  letter-spacing: 0.5px;
  a {
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    transition: all 0.2s ease;
    &:hover {
      color: #fff;
      border-bottom-color: #fff;
    }
  }
}
</style>
